import React, { Component } from 'react';
import { MemoraLogoSmallBlack, WelcomeAvatar } from '../assets';
import {
	Button,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	Spinner,
	Form,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
	login,
	resetPassword,
	signupGoogle,
} from '../redux/actions/auth.action';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withRouter } from 'react-router';
class Register extends Component {
	state = {
		tab: 'sign_up',
		modals: {
			login: false,
			password: false,
			newPassword: false,
			forgetPassword: false,
			profile: false,
		},
		formData: {
			email: '',
			password: '',
		},
		sendCode: false,
	};
	changeTab = tab => {
		this.setState({
			tab,
		});
	};
	// componentDidMount = () => {
	// 	const reloadCount = sessionStorage.getItem('reloadCount');
	// 	if (reloadCount < 1) {
	// 		sessionStorage.setItem('reloadCount', String(reloadCount + 1));
	// 		window.location.reload();
	// 	} else {
	// 		sessionStorage.removeItem('reloadCount');
	// 	}
	// };
	handleFormDataChange = e => {
		let { formData } = this.state;
		formData[e.target.name] = e.target.value;
		this.setState({
			formData,
		});
	};
	toggleModal = name => {
		let { modals } = JSON.parse(JSON.stringify(this.state));
		for (let modal of Object.keys(modals)) {
			if (modal != name) modals[modal] = false;
		}

		modals[name] = !modals[name];
		this.setState({
			...this.state,
			modals,
		});
	};
	render() {
		let { auth, authUser, passwordLoading } = this.props;
		if (authUser != null)
			return <Redirect to='/dashboard/manage-account' />;
		return (
			<>
				<div className='container-fluid pt-3'>
					<div className='d-flex align-items-center'>
						<h2 className='font-weight-bold text-uppercase'>
							Registration
						</h2>
					</div>
					<hr />
					<div className='mt-5'>
						<h5 className='font-weight-bold'>Join Memora</h5>
						<p className='mt-2'>
							Your private space to capture life’s most important
							memories
						</p>
						<Button
							className='btn-outline mr-5 mt-5 dashboard-btn'
							onClick={e => this.toggleModal('login')}
						>
							Log in
						</Button>
						<Button
							onClick={e =>
								this.props.history.push('/dashboard/signup')
							}
							className='btn-outline mt-5 dashboard-btn'
						>
							Sign up
						</Button>
					</div>
				</div>
				{/* Modals - OK */}
				<Modal
					isOpen={this.state.modals.login}
					size='md'
					toggle={e => this.toggleModal('login')}
					centered
				>
					<ModalBody>
						<div className='d-flex'>
							<span
								className='ml-auto pointer'
								onClick={e => this.toggleModal('login')}
							>
								<i className='fa fa-close'></i>
							</span>
						</div>
						<h5 className='font-weight-bold'>Log In to Memora</h5>
						<Input
							className='custom-form-control mt-4'
							name='email'
							value={this.state.formData.email}
							onChange={e => this.handleFormDataChange(e)}
						></Input>
						<Button
							className='btn-outline mr-5 mt-3 dashboard-btn'
							block
							disabled={this.state.formData.email == ''}
							onClick={e => this.toggleModal('password')}
						>
							Continue with email
						</Button>
						<div className='d-flex align-items-center mt-5'>
							<div>
								<div className='d-flex align-items-center'>
									<p className='m-0'>or Continue with</p>
									<i
										className='fa fa-google ml-3 pointer'
										onClick={() =>
											this.props.signupGoogle(
												this.props.history
											)
										}
									></i>
									{/* <i className="fa fa-facebook ml-3"></i>
                  <i className="fa fa-apple ml-3"></i> */}
								</div>
								<small>
									Don't have account?{' '}
									<Link
										to='/dashboard/signup'
										className='text-uppercase'
									>
										Sign up
									</Link>
								</small>
							</div>
							<a
								onClick={e =>
									this.toggleModal('forgetPassword')
								}
								className='ml-auto text-decoration-underline'
								style={{
									fontSize: 14,
									textDecoration: 'underline',
								}}
							>
								Forgot Password?
							</a>
						</div>
					</ModalBody>
				</Modal>

				<Modal
					isOpen={this.state.modals.password}
					toggle={e => this.toggleModal('password')}
					size='md'
					centered
				>
					<ModalBody>
						<div className='d-flex'>
							<span
								className='pointer'
								onClick={e => this.toggleModal('login')}
							>
								<i className='fa fa-arrow-left'></i>
							</span>
							<span
								className='ml-auto pointer'
								onClick={e => this.toggleModal('password')}
							>
								<i className='fa fa-close'></i>
							</span>
						</div>
						<h5 className='font-weight-bold m-0'>Welcome!</h5>
						<small className='m-0'>
							{this.state.formData.email}
						</small>
						<Input
							type='password'
							className='custom-form-control mt-4'
							name='password'
							value={this.state.formData.password}
							onChange={e => this.handleFormDataChange(e)}
						></Input>
						{/* <div className="d-flex align-items-center mt-2">
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" name="checkbox" /> Keep me log In
                </Label>
              </FormGroup>
            </div> */}
						<Button
							className='btn-outline mr-5 mt-3 dashboard-btn'
							onClick={e =>
								this.props.login(
									{ ...this.state.formData },
									this.props.history
								)
							}
							disabled={this.props.auth.requested}
						>
							{this.props.auth.requested ? (
								<Spinner size='sm' />
							) : (
								'Login'
							)}
						</Button>
					</ModalBody>
				</Modal>

				<Modal
					isOpen={this.state.modals.forgetPassword}
					size='md'
					centered
					toggle={e => this.toggleModal('forgetPassword')}
				>
					<ModalBody>
						<div className='d-flex'>
							<span
								className='ml-auto'
								onClick={e =>
									this.toggleModal('forgetPassword')
								}
							>
								<i className='fa fa-times'></i>
							</span>
						</div>
						<h5 className='font-weight-bold'>Forgot Password?</h5>
						<p className='mt-2'>
							Please enter your email address to reset the
							password
						</p>
						<Form
							onSubmit={e => {
								e.preventDefault();
								let email = e.target.email.value;
								this.props
									.resetPassword(email, window.location.href)
									.then(res => {
										this.toggleModal('forgetPassword');
									});
							}}
						>
							<FormGroup className='mt-4'>
								<Label>Email</Label>
								<Input
									className='custom-form-control'
									name='email'
									type='email'
									value={this.state.formData.email}
									onChange={e => this.handleFormDataChange(e)}
								></Input>
							</FormGroup>
							<Button
								className='btn-outline mr-5 mt-3 dashboard-btn'
								type='submit'
								disabled={
									this.state.formData.email == '' ||
									passwordLoading
								}
							>
								{passwordLoading ? (
									<Spinner size='md' />
								) : (
									'Reset Password'
								)}
							</Button>
						</Form>
						<div className='d-flex mt-3'>
							Need help?{' '}
							<a className='ml-1' href=''>
								Contact us
							</a>
						</div>
					</ModalBody>
				</Modal>

				<Modal
					isOpen={this.state.modals.newPassword}
					size='md'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('newPassword')}
				>
					<ModalBody>
						<div className='d-flex'>
							<span
								className='ml-auto'
								onClick={e => this.toggleModal('newPassword')}
							>
								<i className='fa fa-times'></i>
							</span>
						</div>
						<h5 className='font-weight-bold'>Forgot Password?</h5>
						<p className='mt-2'>Please enter new password</p>
						<FormGroup className='mt-4'>
							<Label>Password</Label>
							<Input className='custom-form-control'></Input>
						</FormGroup>
						<FormGroup className='mt-4'>
							<Label>Confirm Password</Label>
							<Input className='custom-form-control'></Input>
						</FormGroup>
						<Button
							className='btn-outline mr-5 mt-3 dashboard-btn'
							onClick={e => this.toggleModal('newPassword')}
						>
							Submit
						</Button>
						<div className='d-flex mt-3'>
							Need help?{' '}
							<a className='ml-1' href=''>
								Contact us
							</a>
						</div>
					</ModalBody>
				</Modal>

				<Modal
					isOpen={this.state.modals.profile}
					size='xl'
					centered
					className='custom-modal'
					toggle={e => this.toggleModal('profile')}
				>
					<ModalBody>
						<div className='modal-content-wrapper text-center'>
							<h5 className='text-center font-weight-bold'>
								Welcome Isma Islam
							</h5>
							<small className='text-center text-muted d-block'>
								Thanks for signing up. Here are some items to
								get you started.
							</small>
							<div className='position-relative d-inline-block my-0 mx-auto'>
								<div
									className='image-update'
									style={{ width: 168, height: 168 }}
								>
									<img
										src={WelcomeAvatar}
										style={{ width: '100%' }}
									/>
								</div>
								<div
									className='image-update-icon'
									style={{
										width: 34,
										height: 34,
										fontSize: 12,
									}}
								>
									<i className='fa fa-camera'></i>
								</div>
							</div>
							<h5 className='text-center mt-5 font-weight-bold'>
								What would you like to do?
							</h5>
							<div className='row mt-4'>
								<div className='col-md-6 col-lg-4 mt-3 mt-md-0'>
									<div className='card h-100 text-center pointer welcome-card'>
										<div className='card-body d-flex align-items-center'>
											<div>
												<img
													src={MemoraLogoSmallBlack}
													style={{ height: 70 }}
												/>
												<h6
													className='mt-4 text-uppercase font-weight-bold'
													style={{
														letterSpacing: '2px',
													}}
												>
													Create a Momoir
												</h6>
												<small>
													On your own visual Timeline
												</small>
											</div>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 mt-3 mt-md-0'>
									<div
										className='card h-100 text-center pointer welcome-card'
										onClick={e => {
											this.props.history.push({
												pathname: '/dashboard/timeline',
												state: { createMemoir: true },
											});
										}}
									>
										<div className='card-body d-flex align-items-center'>
											<div>
												<span
													style={{
														fontSize: 72,
														lineHeight: '1px',
														height: 70,
													}}
												>
													+
												</span>
												<h6
													className='mt-4 text-uppercase  font-weight-bold'
													style={{
														letterSpacing: '2px',
													}}
												>
													Start a new life story
												</h6>
												<small>
													For a loved one, memorial
													something else
												</small>
											</div>
										</div>
									</div>
								</div>
								<div className='col-md-6 col-lg-4 mt-3 mt-md-0'>
									<div className='card h-100 text-center pointer welcome-card'>
										<div className='card-body d-flex align-items-center'>
											<div>
												<img
													src={MemoraLogoSmallBlack}
													style={{ height: 70 }}
												/>

												<h6
													className='mt-4 text-uppercase  font-weight-bold'
													style={{
														letterSpacing: '2px',
													}}
												>
													Send a future message
												</h6>
												<h6>
													Months, years and decades
													from now
												</h6>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</ModalBody>
				</Modal>
			</>
		);
	}
}

const mapStateToProps = state => {
	return {
		auth: state.auth,
		passwordLoading: state.auth.passwordLoading,
		authUser: state.authUser,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		login: (creds, history) => dispatch(login(creds, history)),
		resetPassword: (email, url) => dispatch(resetPassword(email, url)),
		signupGoogle: router => dispatch(signupGoogle(router)),
	};
};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Register)
);
